import useMediaQuery from "@mui/material/useMediaQuery";
import { STORELOCATORACTIONS } from "../../_foundation/constants/common";
import { StyledBox, StyledButton, StyledTypography } from "../../styled-mui";
import { SvgLocationOnOutlined } from "../svg/locationOnOutlined";
import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import { useStoreLocatorValue } from "../../_foundation/context/store-locator-context";
import { useDispatch, useSelector } from "react-redux";
import { STORES_OPEN_MODAL_ACTION } from "../../redux/actions/stores";
import { modalType } from "../../types/store-types";
import { getOpening, transformStore } from "../../utils/storeLocatorUtils";
import { userAttributesSelector } from "../../redux/selectors/user";
import { useFetch } from "../../utils/hooks/useFetch";
import getDisplayName from "react-display-name";
import storeLocatorService from "../../_foundation/apis/transaction/storeLocator.service";
import useUpdateEffect from "../../utils/hooks/useUpdateEffect";
import AsyncCall from "../../_foundation/gtm/async.service";
import { CLICK } from "../../_foundation/constants/gtm";
import { LocationIcon } from "./NavgationBarSvg";
import { Box, Stack } from "@mui/material";

export const StoreLocatorButton = () => {
  const isMobile = useMediaQuery("(max-width:1199px)");
  const widgetName = getDisplayName(StoreLocatorButton);

  const { userFavStoreId } = useSelector(userAttributesSelector);

  const { data } = useFetch(
    storeLocatorService.findByStoreUniqueIds,
    {
      widget: widgetName,
      physicalStoreId: userFavStoreId,
    },
    [userFavStoreId],
    userFavStoreId ? true : false
  );

  const dispatch = useDispatch();
  const { dispatch: dispatchStoreLocatorValue, storeLocator } = useStoreLocatorValue();
  const selectedStore = storeLocator?.selectedStore || null;

  useUpdateEffect(() => {
    if (data && data.PhysicalStore && userFavStoreId && !selectedStore) {
      dispatchStoreLocatorValue({
        type: STORELOCATORACTIONS.INIT_STORE_SELECTION,
        payload: { selectedStore: transformStore(data.PhysicalStore[0]) },
      });
    }
  }, [data]);

  const handleOpenModal = () => {
    AsyncCall.sendClick(CLICK.STORE_LOCATOR, {
      click_section: "header",
      click_label: "Mon magasin",
      click_action: "open_popin",
    });
    dispatch(STORES_OPEN_MODAL_ACTION({ modalType: modalType.MapsSelectStore }));
  };

  const storeOpening = getOpening(
    selectedStore?.storeSchedule,
    selectedStore?.storeExceptionalOpening,
    selectedStore?.storeExceptionalClosing
  );

  if (!isMobile) {
    // DESKTOP BTN
    return (
      <StyledGrid item className="separateur">
        <StyledButton
          testId="store-locator-invoker-button"
          variant="text"
          color="black"
          className={
            selectedStore && storeOpening ? (storeOpening?.open ? "store-locator-open" : "store-locator-close") : ""
          }
          onClick={handleOpenModal}
          sx={{
            textTransform: selectedStore && "none",
            mx: { xs: selectedStore && 3, sm: 0 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}>
          <StyledBox
            className={`${
              selectedStore && storeOpening ? (storeOpening?.open ? "store-locator-open" : "store-locator-close") : ""
            }`}
            sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "24px", mb: 0.5 }}>
            <SvgLocationOnOutlined />
          </StyledBox>
          {selectedStore ? (
            <StyledTypography
              variant="body2"
              component="p"
              sx={{ textAlign: "center", fontWeight: "600", fontSize: "12px", lineHeight: "16px !important" }}>
              {selectedStore?.name}
            </StyledTypography>
          ) : (
            <StyledTypography
              variant="body2"
              component="p"
              sx={{ textAlign: "center", fontWeight: "600", fontSize: "12px", lineHeight: "16px !important" }}>
              Mon magasin
            </StyledTypography>
          )}
        </StyledButton>
      </StyledGrid>
    );
  } else {
    // MOBILE BTN
    return (
      <StyledGrid item className="separateur" sx={{ marginBottom: !selectedStore ? 0 : 3 }}>
        <StyledButton
          testId="store-locator-invoker-button"
          variant={!selectedStore ? "outlined" : "text"}
          color={!selectedStore ? "secondary" : "black"}
          className={
            selectedStore && storeOpening ? (storeOpening?.open ? "store-locator-open" : "store-locator-close") : ""
          }
          onClick={handleOpenModal}
          sx={{
            maxHeight: "unset !important",
            width: !selectedStore ? "100%" : "auto",
            textTransform: selectedStore && "none",
            backgroundColor: !selectedStore ? "#c41e3b" : "",
            color: !selectedStore ? "#fff" : "",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "left",
          }}>
          {selectedStore ? (
            <Stack direction="row" columnGap="8px">
              <Box pt={1}>
                <StyledBox className={storeOpening?.open ? "store-locator-open" : "store-locator-close"}>
                  <SvgLocationOnOutlined />
                </StyledBox>
              </Box>
              <Box sx={{ fontSize: "14px", lineHeight: "20px" }}>
                <StyledTypography variant="body2" component="p" sx={{ textDecoration: "underline" }}>
                  {selectedStore?.name}
                </StyledTypography>
                {storeOpening && (
                  <>
                    <StyledTypography
                      variant="caption"
                      component="p"
                      sx={{ fontSize: "13px", fontWeight: "700", mt: 1 }}>
                      {`${storeOpening.label} ${storeOpening.nextState}`}
                    </StyledTypography>
                    <StyledTypography variant="body2" component="p" mt={1} sx={{ textDecoration: "underline" }}>
                      Changer de magasin
                    </StyledTypography>
                  </>
                )}
              </Box>
            </Stack>
          ) : (
            <StyledTypography
              variant="body1"
              component="p"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                textAlign: "center",
                textTransform: "none",
                fontWeight: "700 !important",
                fontSize: "14px",
                lineHeight: "16px",
              }}>
              <LocationIcon />
              Trouver mon magasin
            </StyledTypography>
          )}
        </StyledButton>
      </StyledGrid>
    );
  }
};
